import styled, { css } from "styled-components";

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Th = styled.th`
  text-align: left;
  padding: 12px;
  border-bottom: 1px solid #e5e7eb;
  font-size: 13px;
  font-weight: 600;
  color: #111827;
`;

export const Td = styled.td`
  padding: 12px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 14px;
  color: #111827;
`;

export const Tr = styled.tr`
  &:hover {
    background: #f8fafc;
  }
`;

// クリックできる行（カーソルを出すだけ）
export const ClickableTr = styled(Tr)`
  cursor: pointer;

  ${(p) =>
    p.$visited &&
    css`
      background: #ecfdf5; /* 来場済み：薄い緑 */
    `}

  /* Tr の hover を上書きして、visited 時は少し濃い緑に */
  &:hover {
    background: ${(p) => (p.$visited ? "#d1fae5" : "#f8fafc")};
  }
`;

// 詳細行の背景（行全体に背景をつけたい場合）
export const DetailTr = styled.tr`
  background: #f8fafc;
`;

// 詳細セル（colSpanで使う前提のTd）
export const DetailTd = styled(Td)`
  background: #f8fafc;
  border-bottom: 1px solid #f1f5f9;
`;

// 詳細の中身用のラッパ
export const DetailBox = styled.div`
  padding: 8px 4px;
  word-break: break-all;
`;
